var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehaviorGraphDrinking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 239.998,
    height: 34.0003,
    viewBox: "0 0 239.998 34.0003",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Behavior Card / Graph / Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Graph",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00024 33.0001C1.00024 33.0001 24.8379 27.0001 33.725 27.0001C42.612 27.0001 51.8372 29.9406 60.4997 27.005C69.1623 24.0694 70.9506 20.9889 78.3496 23.0001C85.7485 25.0113 92.832 25.0113 96.1994 23.0001C99.5668 20.9889 96.288 20.0001 108.099 20.0001C119.911 20.0001 118.86 14.3457 122.974 11.0001C127.088 7.65437 133.151 4.17706 143.799 7.00005C154.447 9.82305 161.7 7.9616 164.624 6.00005C167.548 4.03851 169.985 3.00005 176.524 3.00005C183.062 3.00005 183.002 5.00005 188.424 5.00005C193.845 5.00005 195.562 7.00005 203.299 7.00005C211.035 7.00005 215.42 2.00257 221.148 2.00257C226.877 2.00257 238.998 1.00005 238.998 1.00005V33.0001H1.00024Z",
    fill: "url(#paint0_linear_0_118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 348",
    opacity: 0.5,
    d: "M1.00268 13.0001L239.001 13",
    stroke: "#5CB5F5",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeDasharray: "0.1 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Graph_2",
    d: "M1.00024 33.0001C1.00024 33.0001 24.8379 27.0001 33.725 27.0001C42.612 27.0001 51.8372 29.9406 60.4997 27.005C69.1623 24.0694 70.9506 20.9889 78.3496 23.0001C85.7485 25.0113 92.832 25.0113 96.1994 23.0001C99.5668 20.9889 96.288 20.0001 108.099 20.0001C119.911 20.0001 118.86 14.3457 122.974 11.0001C127.088 7.65437 133.151 4.17706 143.799 7.00005C154.447 9.82305 161.7 7.9616 164.624 6.00005C167.548 4.03851 169.985 3.00005 176.524 3.00005C183.062 3.00005 183.002 5.00005 188.424 5.00005C193.845 5.00005 195.562 7.00005 203.299 7.00005C211.035 7.00005 215.42 2.00257 221.148 2.00257C226.877 2.00257 238.998 1.00005 238.998 1.00005",
    stroke: "#5CB5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_118",
    x1: 1.50673,
    y1: 1.00005,
    x2: 1.50673,
    y2: 32.8639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB5F5",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB5F5",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorGraphDrinking);
export default __webpack_public_path__ + "static/media/behavior-graph-drinking.f1c9346f16681616d48c99c964c42823.svg";
export { ForwardRef as ReactComponent };